import React, { lazy, Suspense } from 'react'

const LazyVideo = lazy(() => import('./Components/Video/VideoWelcome'))
const LazyNavBar = lazy(() => import('./Components/Navbar/NavBar'))
const LazPcNavbar = lazy(() => import('./Components/Navbar/PcNavbar'))
const LazyWelcome = lazy(() => import('./Components/Welcome/Welcome'))
const LazyProducts = lazy(() => import('./Components/Productos/Products'))
const LazyServices= lazy(() => import('./Components/Productos/Services'))
const LazyContacto = lazy(() => import('./Components/Contacto/Contacto'))

import video from "/Videos/Mtvideo.mp4"
import Portada from "/Videos/Portada.jpg"
import Charging from './Components/Charging/Charging'


function App() {

  return (
    <div className="overflow-x-hidden">
      <Suspense fallback={<Charging />}>
        <LazyVideo src={video} poster={Portada}/>
        <LazyNavBar ComponentFolder='Navbar' Component='NavBar'/>
        <LazPcNavbar/>
        <LazyWelcome/>
        <LazyProducts/>
        <LazyServices/>
        <LazyContacto/>
      </Suspense>
    </div>
  )
}

export default App
